import React from 'react';
import {
  defineMessages,
  FormattedMessage,
  IntlShape,
  injectIntl,
} from 'react-intl';

import Checkbox from 'src/components/general-ui/Checkbox';
import {
  SubtenantItem,
  TenantSubscriptionDetails,
} from 'src/routes/GMDashboard/modules/types';
import {
  CheckboxesWrapper,
  EmailSubscriptionWrapper,
  MedicalAlertSettingsWrapper,
} from './styled';
import { deepEqual } from 'src/utils/comparators';

type Props = {
  subscriptionDetails: TenantSubscriptionDetails;
  selectedSubtenants: SubtenantItem[];
  setSubscriptionDetails: React.Dispatch<
    React.SetStateAction<TenantSubscriptionDetails>
  >;
  intl: IntlShape;
};

const MTMMedicalAlerts = ({
  subscriptionDetails,
  selectedSubtenants,
  setSubscriptionDetails,
  intl,
}: Props): JSX.Element => {
  return (
    <MedicalAlertSettingsWrapper>
      <FormattedMessage {...messages.notificationInfo} />
      <CheckboxesWrapper>
        <EmailSubscriptionWrapper>
          <Checkbox
            disabled={!selectedSubtenants.length}
            label={intl.formatMessage(messages.email)}
            checked={subscriptionDetails.MEDICAL.EMAIL.isAssigned}
            handleChange={value => {
              if (!value) {
                setSubscriptionDetails({
                  ...subscriptionDetails,
                  MEDICAL: {
                    ...subscriptionDetails.MEDICAL,
                    EMAIL: {
                      isAssigned: false,
                      withPersonalDetails: false,
                    },
                  },
                });

                return;
              }

              setSubscriptionDetails({
                ...subscriptionDetails,
                MEDICAL: {
                  ...subscriptionDetails.MEDICAL,
                  EMAIL: {
                    ...subscriptionDetails.MEDICAL.EMAIL,
                    isAssigned: value,
                  },
                },
              });
            }}
          />
        </EmailSubscriptionWrapper>
        <Checkbox
          disabled={!selectedSubtenants.length}
          label={intl.formatMessage(messages.sms)}
          checked={subscriptionDetails.MEDICAL.SMS.isAssigned}
          handleChange={value =>
            setSubscriptionDetails({
              ...subscriptionDetails,
              MEDICAL: {
                ...subscriptionDetails.MEDICAL,
                SMS: { ...subscriptionDetails.MEDICAL.SMS, isAssigned: value },
              },
            })
          }
        />
      </CheckboxesWrapper>
    </MedicalAlertSettingsWrapper>
  );
};

export const messages = defineMessages({
  notificationInfo: {
    defaultMessage: 'Send me notification by:',
  },
  email: {
    defaultMessage: 'Email',
  },
  sms: {
    defaultMessage: 'SMS',
  },
});

export default injectIntl(
  React.memo(MTMMedicalAlerts, (oldProps, newProps) =>
    deepEqual(oldProps, newProps),
  ),
);
